import { Component, OnInit, Input } from '@angular/core';
import { RemoteAssessment } from 'app/model/remote-assessment';
import { NgWizardService } from 'ng-wizard';
import { CrmService } from 'app/services/crm.service';
import { SelfDeclaration } from 'app/model/self-declaration';
import { Lookup } from 'app/model/lookup';
import { ContextService } from 'app/services/context.service';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastService } from 'app/services/toast.service';

@Component({
  selector: 'app-self-declaration',
  templateUrl: './self-declaration.component.html',
  styleUrls: ['./self-declaration.component.css']
})
export class SelfDeclarationComponent implements OnInit {
  remoteAssessment: RemoteAssessment;
  agreedToTerms: boolean = false;
  userName: string;
  pharmacyName: string;
  @BlockUI() blockUI: NgBlockUI;

  constructor(private ngWizardService: NgWizardService, private crmService: CrmService, private context: ContextService, private toastService: ToastService) { }

  ngOnInit(): void {
    
    this.context.remoteAssessment.subscribe(ra => this.remoteAssessment = ra);
    this.context.params.subscribe(p => {
      console.log(p);
      this.userName = p[2];
      this.pharmacyName = p[3];
      
    });
  }

  nextStep() {
    if (this.remoteAssessment.readOnly) {
      this.ngWizardService.next();
      return;
    }
    if (this.remoteAssessment?.selfDeclaration) {
      this.ngWizardService.next();
    }
    else {
      if (this.agreedToTerms) {
        this.blockUI.start();
        var selfDeclaration = new SelfDeclaration();
        selfDeclaration.assessment = this.remoteAssessment.assessmentLookup;
        selfDeclaration.contact = this.remoteAssessment.contactLookup;

        var seldDeclarationSub = this.crmService.CreateSelfDeclaration(selfDeclaration).subscribe(sd => {
          this.remoteAssessment.selfDeclaration = sd;
          this.context.updateContextRA(this.remoteAssessment);
          seldDeclarationSub.unsubscribe();
          this.blockUI.stop();
          this.ngWizardService.next();
        })
      } else {
        this.toastService.showDanger("You must agree to the conditions before proceeding");
      }
    }
  }

  getDate(date) {
    if (date) {
      var currentDate = new Date(parseInt(date.substr(6)));
      return currentDate;
    }

  }

}
